<template>
  <div class="review-criteria-list" :class="classes">
    <scroll-view :max-height="maxHeight">
      <review-criteria-list-item
        v-for="(criteria, i) in reviewCriteria"
        :key="criteria.id"
        :value="criteria"
        :index="i + 1"
        :allow-delete="allowDelete"
        :editing="isEditingCriteria(criteria)"
        :selected="isSelected(criteria)"
        @click="onCriteriaClick(criteria)"
        @save="onSaveCriteria(criteria)"
        @delete="$emit('delete-criteria', criteria)"
      />
      <slot></slot>
    </scroll-view>
  </div>
</template>

<script>
import ScrollView from '@/components/Common/ScrollView';
import ReviewCriteriaListItem from './ReviewCriteriaListItem';
import { ReviewCriteria } from '@/models';

export default {
  name: 'ReviewCriteriaList',
  components: { ScrollView, ReviewCriteriaListItem },
  props: {
    value: {
      type: ReviewCriteria,
      default: null,
    },
    reviewCriteria: {
      type: Array,
      default: () => [],
    },
    criteriaType: {
      type: String,
      default: 'INCLUSION',
    },
    allowEdit: {
      type: Boolean,
      default: false,
    },
    allowDelete: {
      type: Boolean,
      default: false,
    },
    allowSelect: {
      type: Boolean,
      default: false,
    },
    maxHeight: {
      type: String,
      default: '300px',
    },
  },
  data: () => ({ editing: [] }),
  computed: {
    classes() {
      return this.criteriaType === 'INCLUSION'
        ? 'inclusion'
        : 'exclusion';
    },
    selected: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    onCriteriaClick(criteria) {
      if (this.allowEdit) {
        this.editing.push(criteria.id);
      }
      if (this.allowSelect) {
        this.selected = this.selected === criteria ? null : criteria;
      }
    },
    isSelected(criteria) {
      return this.selected === criteria;
    },
    isEditingCriteria(criteria) {
      return this.editing.includes(criteria.id);
    },
    onSaveCriteria(criteria) {
      this.editing = this.editing.filter((id) => id !== criteria.id);
      this.$emit('save-criteria', criteria);
    },
  },
};
</script>

<style lang="scss" scoped>
.review-criteria-list {
  overflow: hidden;
  border-radius: 5px;
}
.review-criteria-list.inclusion {
  border: 1px solid var(--v-success-base);
}
.review-criteria-list.exclusion {
  border: 1px solid var(--v-error-base);
}
</style>
